import { css } from "glamor";
import React from "react";
import { Pagination } from "semantic-ui-react";
import {
  Button,
  Link,
  Spinner,
  colors,
  spacing,
  styles,
} from "../../library";
import SurveyModalContainer from "../../surveys/SurveyModalContainer";
import EmptyMocks from "../../mocks/EmptyMocks";
import FilterFormContainer from "../../mocks/FilterFormContainer";
import MockListItemContainer from "./MockListItemContainer";

const container = css({
  textAlign: "center",
  padding: spacing.m,
});
const titleWrapper = css({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: spacing.m,
});
const titleClass = css(styles.alternativeFontFamily, {
  display: "flex",
  alignItems: "center",
  gap: spacing.s,
  fontSize: 24,
  fontWeight: "bold",
  color: colors.secondary,
  lineHeight: 1.5,
});
const activePaginationItem = {
  ...styles.cardShadow,
  borderRadius: "10px",
  background: colors.white,
};
const paginationClass = css({
  paddingBottom: spacing.m,
  borderBottom: "none !important",
  ".ui.secondary.pointing.menu .item": {
    border: "none",
    ":hover": {
      ...activePaginationItem,
      background: "transparent",
      border: `1px solid ${colors.grey}`,
    },
  },
  ".ui.secondary.pointing.menu .active.item": activePaginationItem,
});
const paginationWrapper = css({
  display: "flex",
  justifyContent: "center",
});
const listWrapper = css({
  marginTop: spacing.m,
});

const MockPaginatedList = ({
  mocks,
  currentPage,
  fetchMocksHandler,
  totalPages,
  hasMockCourses,
}) => {
  return mocks.length > 0 ? (
    <div className={listWrapper}>
      {mocks.map((mock) => (
        <MockListItemContainer
          key={mock.id}
          mock={mock}
          routePrefix="/mobile"
        />
      ))}

      <div className={paginationWrapper}>
        <Pagination
          className={paginationClass}
          firstItem={null}
          lastItem={null}
          pointing
          secondary
          activePage={currentPage}
          onPageChange={fetchMocksHandler}
          totalPages={totalPages}
        />
      </div>
    </div>
  ) : (
    <EmptyMocks hasMockCourses={hasMockCourses} />
  );
};

export default function MockList({
  mocks,
  currentPage,
  totalPages,
  fetchMocksHandler,
  loading,
  isFirstMock,
  hasMockCourses,
}) {
  return (
    <div className={container}>
      <div className={titleWrapper}>
        <div className={titleClass}>Simulados</div>
        <Link
          component={Button}
          to="/mobile/questions"
          color="outline"
          circular={false}
          size="small"
        >
          Buscar questões
        </Link>
      </div>

      <FilterFormContainer />
      <SurveyModalContainer type="first_mock" condition={isFirstMock} />
      {loading ? (
        <Spinner wrapped text="Carregando simulados" />
      ) : (
        <MockPaginatedList
          mocks={mocks}
          currentPage={currentPage}
          fetchMocksHandler={fetchMocksHandler}
          totalPages={totalPages}
          hasMockCourses={hasMockCourses}
        />
      )}
    </div>
  );
}
